import { Check } from "lucide-react";

const STEPS = ["Ping", "Download", "Upload"];

export const PhaseSteps = ({ phase }) => {
  const idx = phase === "Complete" || phase === "Saving" ? 3 : STEPS.indexOf(phase);
  return (
    <div className="flex justify-center gap-2 mt-2" data-testid="phase-steps">
      {STEPS.map((s, i) => {
        const done = idx > i, active = idx === i;
        return (
          <span key={s} className={`flex items-center gap-1 rounded-full px-3 py-1 text-[11px] transition-colors duration-200 ${
            active ? "bg-[#007AFF] text-white" : done ? "bg-[#32D74B]/15 text-[#32D74B]" : "bg-white/[0.05] text-neutral-500"}`}>
            {done && <Check className="w-3 h-3" />}{s}
          </span>
        );
      })}
    </div>
  );
};
